/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardSpiderModel } from './DashboardSpiderModel';
import {
  DashboardSpiderModelFromJSON,
  DashboardSpiderModelFromJSONTyped,
  DashboardSpiderModelToJSON,
} from './DashboardSpiderModel';

/**
 *
 * @export
 * @interface DashboardSpiderModels
 */
export interface DashboardSpiderModels {
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderModels
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderModels
   */
  maxCount: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSpiderModels
   */
  restValue: number | null;
  /**
   *
   * @type {Array<DashboardSpiderModel>}
   * @memberof DashboardSpiderModels
   */
  results: Array<DashboardSpiderModel>;
}

/**
 * Check if a given object implements the DashboardSpiderModels interface.
 */
export function instanceOfDashboardSpiderModels(value: object): value is DashboardSpiderModels {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('maxCount' in value) || value['maxCount'] === undefined) return false;
  if (!('restValue' in value) || value['restValue'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function DashboardSpiderModelsFromJSON(json: any): DashboardSpiderModels {
  return DashboardSpiderModelsFromJSONTyped(json, false);
}

export function DashboardSpiderModelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardSpiderModels {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    maxCount: json['max_count'],
    restValue: json['rest_value'],
    results: (json['results'] as Array<any>).map(DashboardSpiderModelFromJSON),
  };
}

export function DashboardSpiderModelsToJSON(value?: DashboardSpiderModels | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    max_count: value['maxCount'],
    rest_value: value['restValue'],
    results: (value['results'] as Array<any>).map(DashboardSpiderModelToJSON),
  };
}
